<template>
	<div class="f-email-domain inputfield inputfield--email-domain" v-if="field.name">
		<input
		class="st-input st-input--full"
		type="text"

		v-validate="getFieldValidation(field)"
		v-model="value"
		:disabled="systemdisable"
		:class="{'st-input--error': errors.has(field.name)}"
		:id="field.name"
		:name="field.name"
		:autocomplete="field.autocomplete"
		:placeholder="(field.placeholder ? $t(field.placeholder) : '')" />
		<div class="error" v-show="errors.has(field.name)">
			{{ errors.first(field.name) }}
		</div>
	</div>
</template>

<script>

import fieldvalidation from '@/helpers/fieldvalidation';

export default {
	name: 'f-email-domain',
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return field.value
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	methods: {
		...fieldvalidation
	}
}
</script>



// WEBPACK FOOTER //
// src/components/form/f-email_domain.vue